module.exports = __webpack_public_path__ + "static/media/apple-store.2928664f.svg";